export const isProduction = process.env.NODE_ENV === "production";
export const baseUrl =
  process?.env?.CANONICAL_TAG || "https://www.petanjo.com/";

export const FALLBACK_ICON =
  "https://cms.cobasi.com.br/uploads/default_image_b0808d5de7.png";

export const Keyword = {
  VER_TODOS: "Ver todos",
  SCHEDULED_BUYS: "Compras Programadas",
  ORDER: "Pedidos",
  BLOG: "Blog",
  OLA: "Olá",
  CONFIRMACAO: "Gostaria de sair da sua conta?",
  CANCEL: "Agora não",
  EXIT: "sair",
  SIM: "Sim",
  CATEGORIAS: "Categorias",
  WELCOME: "Boas-vindas à Cobasi",
  ALL: "Todos",
  COBASI_WORLD: "Mundo Cobasi",
  LEARN_MORE: "Saiba mais",
  SHIP_FROM_STORE_NAME: "Cobasi Já"
};

export const Descriptors = {
  PARA_SEU_PET_OU_SUA_CASA_PROCURE_AQUI:
    "Para seu pet ou sua casa, procure aqui",
  ADESTRAMENTO: "Adestramento",
  DAY_CARE: "Creche Pet",
  PERSONAL_PET: "Personal Pet",
  ADOPTION: "Adoção",
  LOJAS: "Lojas",
  AMIGO_COBASI: "Amigo Cobasi",
  SERVICOS_PET: "Serviços Pet",
  BANHO_E_TOSA: "Banho e Tosa",
  VETERINARIO: "Veterinário",
  PET_SITTER: "Pet Sitter",
  HOSPEDAGEM_PET: "Hospedagem Pet",
  DOG_WALKER: "Dog Walker",
  ESPACO_PET: "Espaço Pet",
  BLOG: "Blog",
  MY_ACCOUNT: "Minha Conta",
  EXIT: "Sair",
  ENTRE_OU_CADASTRE: "Entre ou cadastre-se",
  WARNING_LOGIN:
    "Quando voltar a acessar, você terá que inserir seu email e senha novamente.",
  SAIR_DA_SUA_CONTA: "Sair da sua conta",
  DOWNLOAD_OUR_APP: "Baixe nosso app",
  FALE_CONOSCO: "Fale conosco",
  DUVIDAS: "Dúvidas",
  ESPECIAIS: "Especiais",
  RACAS: "Raças",
  BUY_BY_WHATSAPP: "Compre pelo Whatsapp",
  SIGA_A_COBASI_NAS_REDES_SOCIAIS: "Siga a Cobasi nas redes sociais",
  FORMAS_DE_PAGAMENTO: "Formas de pagamento: ",
  ATENDIMENTO: "Atendimento",
  SHIP_FROM_STORE_NAME_DESCRIPTION: "Seu pedido entregue em até 1h*"
};

export const AccessibilityLabels = {
  OPEN_MENU: "Abrir Menu",
  SKIP_TO_MAIN_CONTENT: "Pular para conteúdo principal",
  OPEN_MENU_PET_SERVICES: "Abrir Menu Serviços Pet"
};
